import { AmountInfo } from '@/components/dashboard/amount-info';
import { NewsBriefing } from '@/components/dashboard/news-briefing';
import { OrderSituation } from '@/components/dashboard/order-situation';
import { ReviewInquiryStatus } from '@/components/dashboard/review-inquiry';

import { BlogPreview } from '@/components/dashboard/blog-preview';
import { SellerboxAi } from '@/components/dashboard/sellerbox-ai';

import AlertDialog from '@/components/dashboard/alert-dialog';
import { TodaySummary } from '@/components/dashboard/today-summary.tsx';
import { NewsBriefingProvider } from './NewsBriefing/_context/NewsContext';
import {
  DASHBOARD_COLUMN_CLASS_NAME,
  DASHBOARD_GRID_CLASS_NAME,
  dashboardSectionClassNames,
} from './home-dashboard-layout';
import { useMembershipPreviewMode } from '@/components/membership/MembershipContentLock';

const HomePage = () => {
  const isPreviewMode = useMembershipPreviewMode();

  return (
    <div className="scrollbar flex h-full w-full  flex-1 flex-col items-center gap-[16px] overflow-y-auto py-10">
      {!isPreviewMode && <AlertDialog />}
      <div className="flex w-full flex-col items-center px-10  pb-10">
        <div className="w-full space-y-4">
          <div className="text-left text-gr-900 Title1S28">대시보드</div>
          <div className={DASHBOARD_GRID_CLASS_NAME}>
            <div className={DASHBOARD_COLUMN_CLASS_NAME}>
              {/* 오늘 요약 */}
              <div className={dashboardSectionClassNames.todaySummary}>
                <TodaySummary />
              </div>
              {/* 실시간 주문 현황 */}
              <div className={dashboardSectionClassNames.orderSituation}>
                <OrderSituation />
              </div>
              {/* 뉴스 브리핑 */}
              <div className={dashboardSectionClassNames.newsBriefing}>
                <NewsBriefingProvider>
                  <NewsBriefing />
                </NewsBriefingProvider>
              </div>
              {/* 블로그 */}
              <div className={dashboardSectionClassNames.blogPreview}>
                <BlogPreview />
              </div>
            </div>
            <div className={DASHBOARD_COLUMN_CLASS_NAME}>
              {/* 신규 리뷰/문의 */}
              <div className={dashboardSectionClassNames.reviewInquiry}>
                <ReviewInquiryStatus />
              </div>
              {/* 매출 추이 */}
              <div className={dashboardSectionClassNames.amountInfo}>
                <AmountInfo isDashboard />
              </div>
              {/* Sellebox AI */}
              <div className={dashboardSectionClassNames.sellerboxAi}>
                <SellerboxAi />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
